<!-- Desktop: centred row between logo and buttons. Below xl: the burger
     panel, with the login buttons at the end as on bildigsnetz.ch. -->
<nav
  class="navigation"
  id="menu"
  role="menu"
  aria-labelledby="menu-button"
  [ngClass]="{ 'navigation--open': isOpen }">
  <ul class="menu">
    <li class="menu__item">
      <a
        class="menu__item__link"
        routerLink="/jobs"
        routerLinkActive="menu__item__link--active"
        (click)="handleClick()">
        Stellen
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        routerLink="/schools"
        routerLinkActive="menu__item__link--active"
        (click)="handleClick()">
        Schulen
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'stellenchats'"
        (click)="handleClick()">
        Stellenchats
        <span
          class="badge bg-light-success text-light-on-navy font-bold xl:hidden"
          >NEU</span
        >
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'angebot'"
        (click)="handleClick()">
        Angebot
      </a>
    </li>
    <li class="menu__item">
      <a class="menu__item__link" [href]="url + 'news'" (click)="handleClick()">
        News
      </a>
    </li>
  </ul>
  <hr class="divider" />
  <ul class="menu menu--meta">
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'fur-fachkrafte'"
        (click)="handleClick()">
        Für Fachkräfte
      </a>
    </li>
    <li class="menu__item">
      <a class="menu__item__link" [href]="url + 'team'" (click)="handleClick()">
        Über uns
      </a>
    </li>
    <li class="menu__item">
      <a
        class="menu__item__link"
        [href]="url + 'kontakt'"
        (click)="handleClick()">
        Kontakt &amp; Support
      </a>
    </li>
  </ul>
  <div class="actions">
    <a class="actions__login" routerLink="/login" (click)="handleClick()">
      Einloggen
    </a>
    <a class="actions__signup" routerLink="/signup" (click)="handleClick()">
      Registrieren
    </a>
  </div>
</nav>
